// Running inside the ZYNX Android app (client, 2026-10-30): the app shows the
// website's screens in its own WebView for the document chain, under its own
// native header and menu. The app adds "ZynxAndroid" to the WebView's user
// agent; here the website's own top bar, sidebar and floating helpers step
// aside so only the page content shows.
export const EMBEDDED_APP_MARKER = 'ZynxAndroid';

export function isEmbeddedApp(): boolean {
  return typeof navigator !== 'undefined' && navigator.userAgent.includes(EMBEDDED_APP_MARKER);
}
